import { Dialog, DialogActions, DialogContent, DialogContentText, Button} from "@mui/material";
import { t } from "./Util_format";

export default function ModalConfirmCookieDecline({ open, onClose }) {
  const handleClose = (isAccept) => {
    onClose(isAccept);
  };

  return (
    <Dialog
      open={open}
      onClose={() => handleClose(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {t("desc_confirm_cookie_decline")}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          onClick={() => handleClose(false)}
          sx={{ maxWidth: "96px" }}
        >
          {t("no")}
        </Button>
        <Button
          variant="contained"
          onClick={() => handleClose(true)}
          sx={{ maxWidth: "96px" }}
        >
          {t("yes")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
